import TeacherPortalQuestionStatisticsOptions from "./QuestionStatisticsOptions";


const TeacherPortalQuestionStatistics = ({ selectedQuestion, selectedQuestionIndex }) => {

    return (<>
        <div className="bg-white rounded shadow">
            <h2 className="p-4 text-2xl">{"Question " + (selectedQuestionIndex + 1) + ": " + selectedQuestion.activitytitle}</h2>
            <div className="p-4">
                <div className="mb-[30px]">
                    <div className="grid grid-cols-12">
                        <div className="col-span-8">
                            <p dangerouslySetInnerHTML={{ __html: selectedQuestion.datajson.questionDescription }}></p>
                        </div>
                        <div className="col-span-1"></div>
                        {(selectedQuestion.datajson.questionAttachment) ?
                            <div className="col-span-3">
                                <div>
                                    <img src={selectedQuestion.datajson.questionAttachment} alt="" />
                                </div>
                            </div> : null}
                    </div>
                </div>

                <TeacherPortalQuestionStatisticsOptions selectedQuestion={selectedQuestion} />
            </div>
        </div>
    </>)
};

export default TeacherPortalQuestionStatistics